// extracted by mini-css-extract-plugin
module.exports = {"preloader":"_3XWHL","enabled":"mLATz","semi-rotate":"_-93Hx","semiRotate":"_-93Hx","inner-rotate":"Njak4","innerRotate":"Njak4","white":"swe5O","dark":"_2sBQu"};